// 基础模块类型定义

// 缓存项接口
export interface CacheItem {
  data: any;
  timestamp: number;
  ttl: number;
}

// 基础缓存状态
export interface BaseCacheState {
  cache: Map<string, CacheItem>;
}

// 基础缓存动作
export interface BaseCacheActions {
  setCache: (key: string, data: any, ttl?: number) => void;
  getCache: (key: string) => any;
  clearCache: (pattern?: string) => void;
  hasCache: (key: string) => boolean;
  getCacheKeys: () => string[];
  getCacheSize: () => number;
  cacheFirst: <T>(
    key: string,
    apiCall: () => Promise<T>,
    ttl?: number
  ) => Promise<T>;
}

// 基础模块状态（包含缓存）
export type BaseModuleState = BaseCacheState;

// 基础模块动作（包含缓存）
export type BaseModuleActions = BaseCacheActions;

// 缓存配置
export interface CacheConfig {
  defaultTTL: number;
  maxSize: number;
  enableLogging: boolean;
}

// 默认缓存配置
export const DEFAULT_CACHE_CONFIG: CacheConfig = {
  defaultTTL: 5 * 60 * 1000, // 5分钟
  maxSize: 100, // 最大缓存项数
  enableLogging: false,
};
